import React from 'react';
import { TopBar } from './components/TopBar';
import { Hero } from './components/Hero';
import { Problem } from './components/Problem';
import { About } from './components/About';
import { Services } from './components/Services';
import { HowItWorks } from './components/HowItWorks';
import { TargetAudience } from './components/TargetAudience';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { Guarantee } from './components/Guarantee';
import { CTA } from './components/CTA';
import { Footer } from './components/Footer';
import { FloatingWhatsApp } from './components/Shared';
export function App() {
  return <div className="min-h-screen bg-slate-50 font-sans selection:bg-slate-900 selection:text-white" data-id="element-0">
      <TopBar data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <Problem data-id="element-4" />
        <About data-id="element-5" />
        <Services data-id="element-6" />
        <HowItWorks data-id="element-7" />
        <TargetAudience data-id="element-8" />
        <Testimonials data-id="element-9" />
        <FAQ data-id="element-10" />
        <Guarantee data-id="element-11" />
        <CTA data-id="element-12" />
      </main>
      <Footer data-id="element-13" />
      <FloatingWhatsApp data-id="element-14" />
    </div>;
}